<template>
  <div class="search-bar-bg">
    <div class="filter-bar-container">
      <!--    <div class="filter-label">-->
      <!--      <el-icon class="label-icon"><Compass /></el-icon>-->
      <!--      数据筛选下钻：-->
      <!--    </div>-->

      <!-- 1. 省份选择 -->
      <div class="filter-item">
        <span class="item-label">省份:</span>
        <el-select
          v-model="queryParams.provinceCode"
          placeholder="请选择"
          class="dark-select"
          @change="handleProvinceChange"
          clearable
        >
          <el-option v-for="item in regionTreeData" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
      </div>

      <!-- 2. 城市选择 (依赖省份) -->
      <div class="filter-item">
        <span class="item-label">城市:</span>
        <el-select
          v-if="queryParams.provinceCode"
          v-model="queryParams.cityCode"
          placeholder="请选择"
          class="dark-select"
          :disabled="!queryParams.provinceCode"
          @change="handleCityChange"
          clearable
        >
          <el-option v-for="item in currentCityList" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
        <div class="disabled-bg" v-else>请先选择省份</div>
      </div>

      <!-- 3. 区域选择 (依赖城市) -->
      <div class="filter-item">
        <span class="item-label">区域:</span>
        <el-select
          v-if="queryParams.cityCode"
          v-model="queryParams.districtCode"
          placeholder="请选择"
          class="dark-select"
          :disabled="!queryParams.cityCode"
          @change="handleDistrictChange"
          clearable
        >
          <el-option v-for="item in currentDistrictList" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
        <div class="disabled-bg" v-else>请先选择城市</div>
      </div>

      <!-- 4. 小区选择 (依赖区域 + 远程动态搜索) -->
      <div class="filter-item" v-if="needCommunity">
        <span class="item-label">小区:</span>
        <el-select
          v-if="queryParams.districtCode"
          v-model="queryParams.communityCode"
          placeholder="请输入搜索"
          class="dark-select community-select"
          filterable
          clearable
          remote
          reserve-keyword
          :remote-method="searchCommunity"
          :loading="loading"
          :disabled="!queryParams.districtCode"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
          <el-option
            v-for="item in communityOptions"
            :key="item.communityCode"
            :label="item.communityName"
            :value="item.communityCode"
          />
        </el-select>
        <div class="disabled-bg width140" v-else>请先选择区域</div>
      </div>

      <div style="display: flex; flex-direction: row; align-items: center; margin-left: auto; /* 推到最右边 */">
        <!-- 6. 查询按钮 -->
        <el-button type="primary" class="search-btn" @click="doSearch">查询数据</el-button>
        <el-button type="primary" class="search-btn" @click="reset" style="margin-left: 12px">重置</el-button>
      </div>
    </div>
    <div class="filter-bar-container" v-if="needTime || needSn">
      <!-- 5. 无人车 SN (手动输入) -->

      <!--      <div class="filter-label" style="color: #0b1426">-->
      <!--        <el-icon class="label-icon"><Compass /></el-icon>-->
      <!--        数据筛选下钻：-->
      <!--      </div>-->
      <div class="filter-item" v-if="needSn">
        <span class="item-label">无人车SN:</span>
        <el-input v-model="queryParams.snCode" placeholder="请输入SN" class="dark-input" clearable />
      </div>
      <div class="filter-item" v-if="needTime">
        <!--      <div class="time-search-container">-->
        <span class="item-label">时间:</span>

        <!-- 快捷选择按钮 -->
        <div class="shortcut-buttons">
          <button class="shortcut-btn" :class="{ active: activeShortcut === 7 }" @click="handleShortcut(7)">
            近7日
          </button>
          <button class="shortcut-btn" :class="{ active: activeShortcut === 30 }" @click="handleShortcut(30)">
            近30日
          </button>
        </div>

        <!-- 日期区间选择器 -->
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          class="custom-date-picker"
          @change="handleDateChange"
          :clearable="false"
        />
        <!--      </div>-->
      </div>
    </div>
    <!-- 6. 时间区间 -->
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted } from 'vue'
import { Compass, Search } from '@element-plus/icons-vue'
import { useHostAppInstance } from '@zto/zpage'
import dayjs from 'dayjs'
import { deepClone } from '@zto/zpage-core/utils/lodash'
const dateRange = ref([])
const activeShortcut = ref(7) // 默认高亮近7日
const emit = defineEmits(['search'])
const props = withDefaults(
  defineProps<{
    needCommunity: boolean
    needSn: boolean
    needTime: boolean
  }>(),
  {
    needCommunity: true,
    needSn: true,
    needTime: true
  }
)
// ================== 1. 状态定义 ==================
// 查询参数实体
const queryParams = reactive({
  provinceCode: '',
  cityCode: '',
  districtCode: '',
  communityCode: '',
  snCode: ''
})

// 后端返回的省市区树状数据
const regionTreeData = ref([])

// 动态搜索小区的数据和 loading 状态
const communityOptions = ref([])
const loading = ref(false)
const app = useHostAppInstance()

// ================== 2. 模拟后端接口 ==================
// 模拟获取省市区树结构接口
const fetchRegionTreeApi = async () => {
  try {
    const resp = await app.request({
      api: '/sys/admin/statistics/public-statistics/site/region/tree',
      params: {}
    })
    // console.log('====fetchRegionTreeApi resp:', JSON.stringify(resp))
    if (resp) {
      return resp.provinceList || []
    }
    return []
  } catch (e) {
    // console.log('====fetchRegionTreeApi resp e:', JSON.stringify(e))
    return []
  }
}

// 模拟根据条件获取小区列表接口
const fetchCommunityApi = async (params: any) => {
  return new Promise(async resolve => {
    try {
      const resp = await app.request({
        api: '/sys/admin/statistics/public-statistics/community/search',
        params: params
      })
      // console.log('====fetchRegionTreeApi resp:', JSON.stringify(resp))
      if (resp) {
        resolve(resp.data || [])
      } else {
        resolve([])
      }
    } catch (e) {
      resolve([])
    }
  })
}

// ================== 3. 核心计算属性 (级联逻辑) ==================
// 根据当前选中的省，计算出对应的城市列表
const currentCityList = computed(() => {
  if (!queryParams.provinceCode) return []
  const province = regionTreeData.value.find(p => p.code === queryParams.provinceCode)
  return province ? province.children || [] : []
})

// 根据当前选中的市，计算出对应的区域列表
const currentDistrictList = computed(() => {
  if (!queryParams.cityCode) return []
  const city = currentCityList.value.find(c => c.code === queryParams.cityCode)
  return city ? city.children || [] : []
})

// ================== 4. 联动重置逻辑 ==================
// 切换省份：清空下级所有数据
const handleProvinceChange = () => {
  queryParams.cityCode = ''
  queryParams.districtCode = ''
  queryParams.communityCode = ''
  communityOptions.value = [] // 清空下拉列表缓存
}

// 切换城市：清空区域和小区
const handleCityChange = () => {
  queryParams.districtCode = ''
  queryParams.communityCode = ''
  communityOptions.value = []
}

// 切换区域：仅清空小区
const handleDistrictChange = () => {
  queryParams.communityCode = ''
  communityOptions.value = []
}

// ================== 5. 远程动态搜索逻辑 ==================
// 小区输入框每次输入文字时触发
const searchCommunity = async (keyword: any) => {
  if (!queryParams.provinceCode || !queryParams.cityCode || !queryParams.districtCode) return
  if (keyword) {
    loading.value = true
    try {
      // 组装必须的 4 个参数
      const reqData = {
        provinceCode: queryParams.provinceCode,
        cityCode: queryParams.cityCode,
        districtCode: queryParams.districtCode,
        keyword: keyword, // 用户输入的文字
        pageIndex: 1,
        pageSize: 100
      }

      // 调用后端接口
      const res = await fetchCommunityApi(reqData)
      console.log('===小区列表：', JSON.stringify(res))
      communityOptions.value = res
    } catch (error) {
      console.error(error)
      communityOptions.value = []
    } finally {
      loading.value = false
    }
  } else {
    communityOptions.value = [] // 输入框为空时清空列表
  }
}

// ================== 6. 查询与初始化 ==================
// 点击最终查询按钮
const doSearch = () => {
  console.log('执行最终查询，当前所有参数：', queryParams)
  // 这里写真正拉取图表或表格数据的逻辑
  const params = contactParams()
  emit('search', params)
}

const reset = () => {
  queryParams.provinceCode = ''
  queryParams.cityCode = ''
  queryParams.districtCode = ''
  queryParams.communityCode = ''
  queryParams.snCode = ''
  communityOptions.value = [] // 清空下拉列表缓存
  handleShortcut(7)
  doSearch()
}

const contactParams = () => {
  let params = deepClone(queryParams)
  if (!props.needSn) {
    delete params.snCode
  }
  if (!props.needCommunity) {
    delete params.communityCode
  }
  if (props.needTime && dateRange.value.length === 2) {
    params.startDate = dateRange.value[0] + ' 00:00:00'
    params.endDate = dateRange.value[1] + ' 23:59:59'
  }
  return params
}

const handleShortcut = (days: any) => {
  activeShortcut.value = days

  const endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
  const startDate = dayjs().subtract(days, 'day').format('YYYY-MM-DD')

  dateRange.value = [startDate, endDate]
}

const handleDateChange = val => {
  if (!val || val.length !== 2) {
    activeShortcut.value = null
    return
  }

  const start = dayjs(val[0])
  const end = dayjs(val[1])

  // 计算选择的天数差 (加1是因为包含当天)
  const diffDays = end.diff(start, 'day') + 1

  // 如果用户手动选的时间正好是 7天 或 30天，并且结束日期是今天，则高亮对应按钮
  const isEndToday = end.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')

  if (diffDays === 7 && isEndToday) {
    activeShortcut.value = 7
  } else if (diffDays === 30 && isEndToday) {
    activeShortcut.value = 30
  } else {
    activeShortcut.value = null // 清除高亮
  }
}

const getSearchParams = () => {
  return contactParams()
}

defineExpose({
  getSearchParams,
  handleShortcut
})

// 页面加载时获取省市区树结构
onMounted(async () => {
  regionTreeData.value = await fetchRegionTreeApi()
  // handleShortcut(7)
})
</script>

<style scoped>
::v-deep(.el-select) {
  background-color: yellow;
}
::v-deep(.el-input) {
  background-color: #101c33;
}
::v-deep(.el-input.is-disabled) {
  background-color: #f5f7fa; /* 例如，将背景色改为浅灰色 */
  border-color: #e4e7ed; /* 例如，将边框颜色改为浅灰色 */
}
::v-deep(.el-input__inner) {
  background-color: #1a2a46;
  border: 1px solid #1a2a46;
  color: #ffffff;
  box-shadow: 0 0 0 1px #2b3d5b inset; /* 边框颜色 */
}
::v-deep(.el-range-input) {
  background-color: #1a2a46;
}

.disabled-bg {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 120px;
  height: 28px;
  border-radius: 4px;
  background-color: #1a2a46;
  border: 1px solid #1a2a46;
  color: #bfc3cb;
  font-size: 12px;
  padding-left: 7px;
  box-shadow: 0 0 0 1px #2b3d5b inset; /* 边框颜色 */
  &.width140 {
    width: 140px;
  }
}
/* ================== 暗黑主题样式还原 ================== */
.search-bar-bg {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  color: #8a9ab9; /* 浅灰蓝色文字 */
  font-size: 14px;
  border: 1px solid #1a2a46;
  margin: 0 24px;
}
.filter-bar-container {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #8a9ab9; /* 浅灰蓝色文字 */
  font-size: 14px;
}

.filter-label {
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: #a0b2d6;
}
.label-icon {
  margin-right: 5px;
  font-size: 16px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.item-label {
  width: 62px;
  margin-right: 10px;
  white-space: nowrap;
  text-align: right;
}

/* 宽度微调 */
.dark-select {
  width: 120px;
  background-color: #f4511e;
}
.community-select {
  width: 140px;
}
.dark-input {
  width: 120px;
}

/* 查询按钮样式 */
.search-btn {
  background-color: #007aff;
  border: none;
  font-weight: bold;
}
.search-btn:hover {
  background-color: #3395ff;
}
.label {
  color: #8b99c0;
  margin-right: 12px;
  font-size: 14px;
}

/* 快捷按钮组 */
.shortcut-buttons {
  display: flex;
  gap: 8px;
  margin-right: 12px;
}

.shortcut-btn {
  background-color: #1a2754;
  border: 1px solid #1a2754;
  color: #a3b2d6;
  padding: 6px 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  outline: none;
}

.shortcut-btn:hover {
  border-color: #0099ff;
  color: #fff;
}

/* 激活状态的按钮样式 */
.shortcut-btn.active {
  background-color: #0099ff;
  border-color: #0099ff;
  color: #fff;
}

/* 覆盖 Element Plus 日期选择器的默认暗黑样式 */
:deep(.custom-date-picker.el-date-editor) {
  --el-input-bg-color: #0d1638;
  --el-input-border-color: #1a2754;
  --el-input-text-color: #a3b2d6;
  --el-input-icon-color: #a3b2d6;
  box-shadow: none;
  border: 1px solid #23356a;
  margin-right: 12px;
}

:deep(.custom-date-picker .el-range-input) {
  color: #a3b2d6;
}

:deep(.custom-date-picker .el-range-separator) {
  color: #5b6d98;
}
</style>
